<template>
    <main class="game-main" :style="{'height': windowHeight+'px'}">
    <div class="main-wrapper">
        <div class="game-view">
  
        <GameHeader
        
        />

        <InfoContent
        v-if="actualView.type === 'info'"
        />

        <GameSections
        v-if="actualView.type === 'sections'"
        />

        <UniversalAnswers
        v-if="actualView.type === 'answers'"
        />

        <GameFooter 
        :footerData ="actualView.footer"
        />

      </div>
    </div>
  </main>
    
</template>
  
<script>
// import localTestData from '@/data/congress1.json'
import { mapGetters, mapActions } from 'vuex'
import InfoContent from '@/components/game/InfoContent.vue'
import GameSections from '@/components/game/GameSections.vue'

import UniversalAnswers from '@/components/game/UniversalAnswers.vue'
import GameHeader from '@/components/game/GameHeader.vue'
import GameFooter from '@/components/game/GameFooter.vue'
  
export default {
    name: 'GameMain',
    components: {
        InfoContent,
        GameSections,
        UniversalAnswers,
        GameHeader,
        GameFooter
    },
    computed: {
        ...mapGetters([
            'gameData',
            'stepNumber',
            'actualView',
            'windowHeight'
        ]),        
    },
    methods: {
        ...mapActions([
            'GET_DATA_FROM_API',
            'GET_DATA_FROM_LOCAL',
            'setWindowHeight'
        ]),
        onResize() {
            this.setWindowHeight(window.innerHeight)
        }
    },
    created(){
        this.GET_DATA_FROM_API(29)
        // this.GET_DATA_FROM_LOCAL(localTestData)
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    beforeUnmount() { 
        window.removeEventListener('resize', this.onResize);
    },

}
</script>

<style>

</style>
